<template>
  <f7-page>
		<page-nav-bar
      currentServiceName="MoneyRoad"
      :subNavTitle="$t('leftPanelTitle.installments')"
      :menuAccess="true">
    </page-nav-bar>
    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="newRules()">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
    </div>
    <div class="row showLargeScreenOnly">
      <div class="row rowSearchBar" v-bind:class="colorBottomButton">
        <div class="firstButtonMarginLeft showLargeScreenOnly">
          <button class="new-button milkyBlock" @click="newRules()">
            <f7-icon f7="add"></f7-icon>
            <span>{{$t('regles_metier.new_rules')}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="searchFilter searchFilterWithoutTabs">
      <div v-if="loading"><spinner/></div>
      <f7-list media-list v-else>
        <f7-list-item v-for="item in echeancierList"
          :key="item.idReglesMetier"
          :title="item.nom"
          :subtitle="$t('regles_metier.nbecheances_text',{min: item.nbEcheances.min, max: item.nbEcheances.max})"
          :after="item.montant"
          :link="`/settings/echeancier/edit/${item.idReglesMetier}`"></f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>

<script>
import spinner from '@/components/common/spinner.vue'
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'EcheancierListe',
  components: {
    spinner,
    'page-nav-bar': pageNavBar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      echeancierList: [],
      loading: true
    }
  },
  created () {
    this.setEcheancierList()
  },
  methods: {
    setEcheancierList () {
      let that = this
      this.$engine.reglesMetier.get()
      .then(response => {
        this.echeancierList = response.data.reglesMetier
      }).catch(err => {
        errorMessageAlert(err, that)
      }).finally(() => {
        this.loading = false
      })
    },
    newRules () {
      loadPage(this, {url: '/settings/echeancier/add'})
    }
  }
}
</script>

<style lang="css" scoped>
  @media (min-width: 993px) {
    .searchForm {
      margin-top: 0%;
    }
  }
  .milkyBlock.boxRequest.pull-right.new-button {
    width: 125px;
  }
</style>



// WEBPACK FOOTER //
// EcheancierListe.vue?ab909d26